<template>
  <section>
    <div class="flex py-6">
      <a
        v-for="item in menu_buttons"
        @click="selectChoose(item)"
        :key="item.label"
        :class="
          item.active
            ? 'border-ontick-blue-500 text-gray-300'
            : 'border-ontick-carbon-500 text-gray-500'
        "
        class="cursor-pointer border-b px-6 py-2"
      >
        {{ item.label }}
      </a>
    </div>
    <div class="flex w-full py-2 md:w-3/4">
      <div class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
        <treeselect
          :multiple="false"
          :options="investiment"
          :show-count="true"
          :searchable="true"
          :clearable="false"
          placeholder="Selecione seu investimento"
          v-model="select_investment_id"
          @select="selectInvestment"
        >
          <div
            slot="option-label"
            slot-scope="{ node, labelClassName }"
            :class="labelClassName"
            class="py-2"
          >
            <div
              class="flex items-center justify-between"
              v-for="(item, index) in list_investment"
              :key="index"
            >
              <div class="space-x-3" v-if="node.id == item.investment_id">
                <span class="relative -mb-3 inline-flex h-3 w-3 items-center">
                  <span
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                    class="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
                  ></span>

                  <span
                    class="relative inline-flex h-3 w-3 rounded-full"
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                  ></span>
                </span>
                <span class="inline-flex text-sm text-ontick-blue-500">{{
                  item.investment_id
                }}</span>
                <span class="text-sm text-gray-300">{{ node.label }}</span>
              </div>
              <div
                class="float-right ml-2 text-sm text-gray-300"
                v-if="node.id == item.investment_id"
              >
                <div
                  content="Ordens executadas"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  v-show="item.investment_status != 'HIDDEN'"
                  class="mx-2 inline-flex items-center"
                >
                  <p class="mx-2">{{ item.num_positions }}</p>
                </div>
              </div>
            </div>
          </div>
          <div slot="value-label" slot-scope="{ node }" class="w-full">
            <div
              class="flex items-center justify-between"
              v-for="(item, index) in list_investment"
              :key="index"
            >
              <div class="space-x-3" v-if="node.id == item.investment_id">
                <span class="relative -mb-3 inline-flex h-3 w-3 items-center">
                  <span
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                    class="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
                  ></span>

                  <span
                    class="relative inline-flex h-3 w-3 rounded-full"
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                  ></span>
                </span>
                <span class="inline-flex text-sm text-ontick-blue-500">{{
                  item.investment_id
                }}</span>
                <span class="text-sm text-gray-300">{{ node.label }}</span>
              </div>
              <div
                class="float-right ml-2 text-sm text-gray-300"
                v-if="node.id == item.investment_id"
              >
                <div
                  content="Ordens executadas"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  v-show="item.investment_status != 'HIDDEN'"
                  class="mx-2 inline-flex items-center"
                >
                  <p class="mx-2 text-gray-300">{{ item.num_positions }}</p>
                </div>
              </div>
            </div>
          </div>
        </treeselect>
        <div class="relative">
          <VueCtkDateTimePicker
            v-model="select_period"
            label="Selecione o periodo"
            :range="true"
            :dark="true"
            :inline="false"
            locale="pt-BR"
            color="#293241"
            :noClearButton="true"
            button-now-translation="Fechar"
            :custom-shortcuts="customShortcuts"
            :min-date="date_logs.min"
            :max-date="date_logs.max"
            :enabled-dates="active_days"
            formatted="DD/MM/YYYY"
            @validate="dateSelected(select_period)"
            :no-value-to-custom-elem="true"
          >
          </VueCtkDateTimePicker>
          <span class="absolute inset-y-2.5 right-2" v-html="$icons.calendar" />
        </div>
      </div>

      <button
        @click="update()"
        content="Atualizar dados"
        v-tippy="{ arrow: true, theme: 'green' }"
        class="relative col-span-1 ml-2 hidden w-10 items-center py-2 text-ontick-blue-500 md:inline-flex md:px-2"
      >
        <span
          v-html="active_update ? update_icon.active : update_icon.disabled"
        ></span>
      </button>
    </div>
  </section>
</template>

<script>
const customShortcuts = [
  { key: "thisDay", label: "Hoje", value: "day" },
  { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
  { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
  { key: "last7Days", label: "Últimos 7 dias", value: 7 },
  { key: "last30Days", label: "Últimos 30 dias", value: 30 },
  { key: "thisMonth", label: "Esse mês", value: "month" },
  { key: "lastMonth", label: "Mês anterior", value: "-month" },
  { key: "thisYear", label: "Esse ano", value: "year" },
  // { key: "lastYear", label: "Ano anterior", value: "-year" },
];
import { mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
// import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "performance-investment",
  components: {
    Treeselect,
    VueCtkDateTimePicker,
    // menuMobile: () => import("./investiment.mobile.component"),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    dateLogs: {
      type: Object,
      default: null,
    },
    active_days: {
      default: [],
    },
  },
  data() {
    return {
      active_update: false,
      update_icon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
      customShortcuts: customShortcuts,
      date_logs: {
        max: "",
        min: "",
      },
      select_period: {},
      investiment: [],
      list_investment: [],
      select_investment: {},
      select_investment_id: null,
      buttons: "py-2 px-2 rounded text-white w-full",
      menu_buttons: [
        {
          label: "Resumo",
          active: true,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>`,
        },
        {
          label: "Ordens",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`,
        },
        {
          label: "Logs",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`,
        },
      ],
      data_account: [],
    };
  },

  created() {
    this.initListInvestment(this.data);
  },
  methods: {
    ...mapActions({
      toggleAccount: "performance/toggleAccount",
    }),

    initListInvestment(value) {
      let investiment_array = [];
      let order_by = { stopped: [], running: [], hidden: [] };
      this.select_period.start = this.dateCurrent();
      this.select_period.end = this.dateCurrent("end");

      value.accounts.forEach((item_account) => {
        item_account.investments.forEach((item) => {
          investiment_array.push(item);

          let new_investment;

          if (item.investment_status == "STOPPED") {
            if (item.strategies) {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
                investment_profit: item.investment_profit,
                children: [],
              };
              item.strategies.forEach((x) => {
                new_investment.children.push({
                  label: x.investment_name,
                  id: x.investment_id,
                  investment_profit: item.investment_profit,
                });
              });
            } else {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };
            }
            order_by.stopped.push(new_investment);
          } else if (item.investment_status == "RUNNING") {
            if (item.strategies) {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
                investment_profit: item.investment_profit,
                children: [],
              };
              item.strategies.forEach((x) => {
                new_investment.children.push({
                  label: x.investment_name,
                  id: x.investment_id,
                  investment_profit: item.investment_profit,
                });
              });
            } else {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };
            }
            order_by.running.push(new_investment);
          } else {
            if (item.strategies) {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
                investment_profit: item.investment_profit,
                children: [],
              };
              item.strategies.forEach((x) => {
                new_investment.children.push({
                  label: x.investment_name,
                  id: x.investment_id,
                  investment_profit: item.investment_profit,
                });
              });
            } else {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };
            }

            order_by.hidden.push(new_investment);
          }
        });
      });

      this.investiment = order_by.running.concat(
        order_by.stopped,
        order_by.hidden
      );

      if (Object.keys(this.$route.params).length == 0) {
        this.select_investment = this.investiment[0];
        this.select_investment_id = this.investiment[0].id;
      } else {
        this.select_investment_id = this.$route.params.id;
        this.select_investment = {
          id: this.$route.params.id,
          label: this.$route.params.label,
        };

        if (this.$route.params.type == "logs") {
          this.$emit("activeLogs", true);
        }
      }

      this.list_investment = investiment_array;

      this.selectInvestment(this.select_investment);
    },

    dateCurrent(value) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today =
        value == "end"
          ? yyyy + "-" + mm + "-" + dd + "T" + "23:59:59"
          : yyyy + "-" + mm + "-" + dd + "T" + "00:00:00";

      return today;
    },

    selectChoose(value) {
      this.menu_buttons.forEach((item) => {
        item.active = false;
      });
      value.active = true;
      this.$emit("chooseItem", value);
    },

    selectInvestment(investment) {
      this.select_investment = investment;

      let data_investment = {};
      this.list_investment.forEach((item) => {
        if (investment.id == item.investment_id) {
          data_investment = item;
        }
      });

      let params = {
        investment: data_investment,
        date_range: this.select_period,
      };

      this.$emit("listInvestment", params);
    },

    dateSelected(date) {
      this.select_period = date;

      let date_end = date.start.split(" ")[0];

      date.start = date.start.split(" ")[0] + "T" + "00:00:00";

      date.end =
        date.end == null
          ? date_end + "T" + "23:59:59"
          : date.end.split(" ")[0] + "T" + "23:59:59";

      let data_investment = {};
      this.list_investment.forEach((item) => {
        if (this.select_investment.id == item.investment_id) {
          data_investment = item;
        }
      });

      let params = {
        investment: data_investment,
        date_range: date,
      };
      this.$emit("listInvestment", params);
    },

    update() {
      this.active_update = true;
      setTimeout(() => {
        this.active_update = false;
      }, 1000);

      let data_investment = {};
      this.list_investment.forEach((item) => {
        if (this.select_investment.id == item.investment_id) {
          data_investment = item;
        }
      });
      let params = {
        investment: data_investment,
        date_range: this.select_period,
      };

      this.$swal({
        titleText: `Dados atualizados `,
        icon: "success",
        toast: true,
        position: "top-end",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,

        customClass: {
          popup: "sweetalert_popup",
          title: "sweetalert_title_toast",
          confirmButton: "sweetalert_confirm_button",
          content: "sweetalert_popup_toast",
          backdrop: "swal2-backdrop-hide",
        },
      });

      this.$emit("listInvestment", params);
    },

    dateLimitMin() {
      let today = new Date();
      today.setDate(today.getDate() - 7);
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();

      this.date_logs.min = `${year}-${month}-${day}`;
    },

    dateLimitMax() {
      let today = new Date();
      today.setDate(today.getDate());
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();

      this.date_logs.max = `${year}-${month}-${day}`;
    },
  },

  watch: {
    data(value) {
      this.initListInvestment(value);
      return value;
    },

    dateLogs: {
      deep: true,
      handler(value) {
        if (value.orders) {
          // this.dateLimitMin();
          // this.dateLimitMax();
          // this.customShortcuts = [
          //   { key: "thisDay", label: "Hoje", value: "day" },
          //   { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
          // ];
        } else if (value.logs) {
          // this.dateLimitMin();
          // this.dateLimitMax();
          // this.customShortcuts = [
          //   { key: "thisDay", label: "Hoje", value: "day" },
          //   { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
          // ];
          // this.selectInvestment(this.select_investment);
        } else {
          this.date_logs.max = "";
          this.date_logs.min = "";
          this.customShortcuts = customShortcuts;
        }
        return value;
      },
    },
  },

  unmounted: function () {
    this.investiment = [];
  },
};
</script>

<style lang="scss">
// @import "./investment.component.scss";
</style>
